import React, {useEffect, useState} from "react";
import {exibirMensagemSucesso} from "../../util";
import {PaginaLogada} from "../../componentes";
import {useDisclosure} from "@mantine/hooks";
import {ActionIcon, Badge, Center, ColorInput, Grid, Modal, Table, TextInput, Tooltip} from "@mantine/core";
import {BotaoAdicionar, BotaoFechar, BotaoSalvar} from "../../componentes/botao/botao-mantine";
import CardPadrao from "../../componentes/card/card-padrao";
import {useForm} from "@mantine/form";
import {SetorDto} from "../../tipos/dto/setor-dto";
import SetorServico from "../../servicos/setor-servico";
import {COL_RESP_6, COR, ICONE} from "../../config/constantes/constantes-mantine";

export default function Setores() {

  const [modal, {open, close}] = useDisclosure(false);
  const [flagAlterar, setFlagAlterar] = useState(false)
  const [isCarregando, setIsCarregando] = useState(false)
  const [lista, setLista] = useState<SetorDto[]>([])
  const form = useForm({
    initialValues: {
      nome: "",
      sigla:"",
      cor:"",
    },
    validate: {
      nome: (value) => (value.length <= 4 ? "Nome muito curto" : null),
      sigla: (value) => (value.length < 2 ? "sigla muito curta" : null),
      cor: (value) => (value.length < 7 ? "Cor inválida" : null),
    },
    transformValues: (values) => ({
      corSafe: `${values.cor === null ? "" : values.cor}`,
    }),
  });

  async function buscarSetores() {
    setIsCarregando(true)
    const result = await SetorServico.buscarSetores()
    setLista(result)
    setIsCarregando(false)
  }

  function salvarSetor() {
    setIsCarregando(true)
    if (flagAlterar) {
      SetorServico.alterarSetor(form.values)
        .then(r => r.json())
        .then(json => {
          buscarSetores()
          exibirMensagemSucesso("SetorDto alterado com sucesso")
        })
    } else {
      SetorServico.salvarSetor(form.values)
        .then(r => r.json())
        .then(json => {
          lista.push(json)
          setLista(lista)
          exibirMensagemSucesso("SetorDto salvo com Sucesso")
        })
    }
    setIsCarregando(false)
    form.reset()
    close()
  }

  function alterarSetor(s: SetorDto) {
    setFlagAlterar(true)
    delete s.usuarios
    form.setValues(s)
    open()
  }

  useEffect(() => {
    buscarSetores()
  }, [])


  return (
    <PaginaLogada titulo="Setores" isCarregando={isCarregando}>
      <BotaoAdicionar onClick={open} />
      <CardPadrao mt={20}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>ID</Table.Th>
              <Table.Th>Nome</Table.Th>
              <Table.Th>Sigla</Table.Th>
              <Table.Th>Cor</Table.Th>
              <Table.Th>Usuários</Table.Th>
              <Table.Th>Ação</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {lista.map((s, k) => {
              return (
                <Table.Tr key={k}>
                  <Table.Td>{s.id}</Table.Td>
                  <Table.Td>{s.nome}</Table.Td>
                  <Table.Td>{s.sigla}</Table.Td>
                  <Table.Td>
                    <Badge color={s.cor}>
                      {s.cor}
                    </Badge>
                  </Table.Td>
                  <Table.Td>{s.usuarios}</Table.Td>
                  <Table.Td>
                    <Tooltip label={"Editar"}>
                      <ActionIcon
                        aria-label="Editar"
                        color={COR.ALERTA}
                        onClick={() => alterarSetor(s)}
                      >
                        <ICONE.EDITAR/>
                      </ActionIcon>
                    </Tooltip>
                  </Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Tbody>
        </Table>
      </CardPadrao>

      <Modal opened={modal} onClose={() => {close(); setFlagAlterar(false)}} size={"lg"} title={"Cadastrar Setor"}>
        <form onSubmit={form.onSubmit(salvarSetor)}>
          <Grid>
            <Grid.Col span={COL_RESP_6}>
              <TextInput
                label={"Nome"}
                placeholder="Nome do SetorDto"
                {...form.getInputProps('nome')}
                onChange={(e) => form.setFieldValue("nome", e.currentTarget.value.toUpperCase())}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <TextInput
                required
                label={"Sigla"}
                placeholder={"Ex. PRC"}
                {...form.getInputProps('sigla')}
                onChange={(e) => form.setFieldValue("sigla", e.currentTarget.value.toUpperCase())}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <ColorInput
                required
                label={"Cor"}
                placeholder={"#FFFFFF"}
                value={form.getValues().cor === null ? "" : form.getValues().cor}
                onChange={(e) => form.setFieldValue("cor", e.toUpperCase())}
                swatches={['#2e2e2e', '#868e96', '#fa5252', '#e64980', '#be4bdb', '#7950f2', '#4c6ef5', '#228be6', '#15aabf', '#12b886', '#40c057', '#82c91e', '#fab005', '#fd7e14']}
              />
            </Grid.Col>
            <Grid.Col span={12} mt={20}>
              <Center>
                <BotaoSalvar type={"submit"} m={5}/>
                <BotaoFechar onClick={() => {close(); setFlagAlterar(false)}} m={5}/>
              </Center>
            </Grid.Col>
          </Grid>
        </form>
      </Modal>
    </PaginaLogada>
  );
}
